// 法语（法国）
export default {
  company: {
    deviceList: 'Liste des appareils',
    name: 'TIME PHOTO',
    desc: 'Profitez du merveilleux moment!',
    companyName: 'Nom du commerçant',
    companyInfo: 'Informations du commerçant',
    linkMan: 'Personne de contact',
    contactInfo: 'Coordonnées',
    cooperationWay: 'Mode de coopération',
    jointOperation: 'Coexploitation',
    selfOperated: 'Exploitation propre',
    agent: 'Agent',
    businessStatus: 'Statut de l\'activité',
    operating: 'En activité',
    stopped: 'Fermé',
    hasBackend: 'Backend activé',
    backendAccount: 'Compte backend',
    backendPassword: 'Mot de passe backend',
    deviceCount: 'Nombre de machines',
    orderData: 'Données des commandes',
    companyRatio: 'Ratio du commerçant (%)',
    operatorRatio: 'Ratio de l\'opérateur (%)',
    companyDesc: 'Description du commerçant',
    companyAddress: 'Adresse du commerçant',
    openAggregatedPay: 'Paiement agrégé activé',
    thirdPayWay: 'Méthode de paiement tierce',
    merchantId: 'ID du commerçant',
    merchantType: 'Type de commerçant',
    merchantAppid: 'Appid du commerçant',
    wechatRedirectUrl: 'URL de redirection du paiement WeChat',
    payNotifyUrl: 'URL de rappel du paiement',
    refundNotifyUrl: 'URL de rappel du remboursement',
    sqbMerchantCode: 'Code du commerçant (Shouqianba)',
    sqbDeveloperKey: 'Clé développeur Shouqianba',
    storeActiveCode: 'Code d\'activation du magasin',
    frontendCallbackUrl: 'URL de rappel du frontend',
    merchantSecret: 'Secret du commerçant',
    unit: 'unité(s)',
    merchantLevel: 'Niveau du commerçant',
    level2Merchant: 'Commerçant de niveau 2',
    level3Merchant: 'Commerçant de niveau 3',
    aggregatedPayMerchant: 'Commerçant de paiement agrégé',
    backendOpen: 'Backend ouvert',
    forwardIncomingPrefix: 'Huilaimi Entrée_',
    qrCodeGenerateFailed: 'Échec de la génération du code QR, veuillez réessayer',
    invalidWebUrl: 'URL web obtenue non valide, veuillez contacter l\'administrateur',
    noValidWebUrl: 'Aucune URL web valide obtenue',
    fetchDataFailed: 'Échec de la récupération des données, veuillez réessayer',
    browserNotSupportDownload: 'Votre navigateur ne prend pas en charge le téléchargement automatique, veuillez faire un clic droit pour enregistrer l\'image',
    downloadImageFailed: 'Échec du téléchargement de l\'image, veuillez réessayer',
    httpError: 'Erreur HTTP, code d\'état : {status}',
    copyCompanyName: 'Copier le nom du commerçant',
    copySuccess: 'Copie réussie',
    copyFail: 'Échec de la copie'
  },
  income: {
    totalIncome: 'Montant total des commandes',
    platformIncome: 'Part de la plateforme',
    companyIncome: 'Revenus du système marchand',
    subMerchantIncome: 'Part du sous-commerçant',
    parentIncome: 'Retenu du commerçant supérieur',
    orderCount: 'Nombre de commandes',
    subMerchantIncomeDetail: 'Détail des revenus des sous-commerçants',
    subRatioText: 'Retenu de niveau trois',
    subJustRatioText: 'Commission de niveau deux',
    splitRatio: 'Ratio de répartition',
    deviceCount: 'Nombre d\'appareils',
    deviceCode: 'Code de l\'appareil',
    deviceName: 'Nom de l\'appareil'
  },
  login: {
    username: 'Nom d\'utilisateur',
    password: 'Mot de passe',
    login: 'Connexion',
    inputUsername: 'Veuillez entrer le nom d\'utilisateur',
    inputPassword: 'Veuillez entrer le mot de passe'
  },
  employee: {
    inputAccount: 'Veuillez saisir le compte',
    inputName: 'Veuillez saisir le nom',
    inputMobile: 'Veuillez saisir le numéro de mobile',
    selectRole: 'Veuillez sélectionner le rôle',
    allRoles: 'Tous les rôles',
    allStatus: 'Tous les statuts',
    collapse: 'Réduire',
    expand: 'Développer',
    employeeCount: 'Nombre d\'employés : ',
    addEmployee: '+ Ajouter un employé',
    account: 'Compte',
    name: 'Nom',
    gender: 'Sexe',
    role: 'Rôle',
    company: 'Entreprise associée',
    creator: 'Ajouté par',
    createTime: 'Date d\'ajout',
    devicePermission: 'Autorisation d\'appareil',
    deviceCountUnit: '{count} appareil(s)',
    viewAllDevices: 'Voir tous les appareils',
    disableAccount: 'Désactiver',
    resetPassword: 'Réinitialiser le mot de passe',
    assignDevices: 'Attribuer des appareils',
    tip: 'Avis',
    deleteConfirm: 'Après la suppression du compte, celui-ci ne pourra plus se connecter au système. Confirmer la suppression ?',
    employeeName: 'Nom de l\'employé : ',
    usernameLabel: 'Nom d\'utilisateur : ',
    currentPermission: 'Autorisation actuelle : ',
    assignedDevices: '{count} appareil(s) attribué(s)',
    selectDevice: 'Sélectionner des appareils : ',
    selectDevicePlaceholder: 'Veuillez sélectionner des appareils',
    deviceHint: 'Ne sélectionner aucun appareil signifie que l\'employé peut voir tous les appareils de l\'entreprise',
    selectAtLeastOneDevice: 'Veuillez sélectionner au moins 1 appareil',
    assignSuccess: 'Appareils attribués avec succès',
    assignFailed: 'Échec de l\'attribution',
    loadDeviceInfoFailed: 'Échec du chargement des informations de l\'appareil',
    loadDeviceListFailed: 'Échec du chargement de la liste des appareils',
    disableConfirmTitle: 'Voulez-vous vraiment désactiver ce compte employé ?',
    disableConfirmContent: 'Après désactivation, l\'employé ne pourra plus se connecter',
    disableSuccess: 'Désactivé avec succès',
    enableConfirmTitle: 'Voulez-vous vraiment activer ce compte employé ?',
    enableConfirmContent: 'Après activation, l\'employé pourra se connecter',
    enableSuccess: 'Activé avec succès',
    resetPwdConfirmTitle: 'Voulez-vous vraiment réinitialiser le mot de passe de cet employé ?',
    resetPwdConfirmContent: 'Après réinitialisation, le mot de passe redeviendra le mot de passe par défaut (JTphoto0515)',
    resetPwdSuccess: 'Mot de passe réinitialisé avec succès',
    addSuccess: 'Employé ajouté avec succès',
    updateSuccess: 'Employé modifié avec succès',
    addTitle: 'Ajouter un employé',
    editTitle: 'Modifier l\'employé',
    accountLabel: 'Compte :',
    nameLabel: 'Nom :',
    passwordLabel: 'Mot de passe :',
    defaultPwdTip: 'Laissez vide pour utiliser le mot de passe par défaut JTphoto0515',
    defaultPwdPlaceholder: 'Laisser vide pour utiliser le mot de passe par défaut',
    emailLabel: 'E-mail :',
    emailInvalid: 'Veuillez saisir un e-mail valide',
    maxLength50: 'La longueur ne peut pas dépasser 50 caractères',
    mobileLabel: 'Mobile :',
    mobileInvalid: 'Veuillez saisir un numéro de mobile valide',
    roleSetting: 'Rôle :',
    statusSetting: 'Statut :',
    selectStatus: 'Veuillez sélectionner le statut',
    genderSetting: 'Sexe :',
    selectGender: 'Veuillez sélectionner le sexe',
    deptSetting: 'Département :',
    remarkLabel: 'Remarque :',
    remarkPlaceholder: 'Veuillez saisir une remarque',
    submit: 'Soumettre',
    save: 'Enregistrer',
    usernameRequired: 'Le nom d\'utilisateur ne peut pas être vide',
    usernameMax20: 'Le nom d\'utilisateur ne peut pas dépasser 20 caractères',
    usernameMin4: 'Le nom d\'utilisateur doit contenir au moins 4 caractères',
    usernameExists: 'Désolé, ce nom d\'utilisateur existe déjà',
    mobileRequired: 'Le numéro de mobile ne peut pas être vide !',
    nameRequired: 'Le nom ne peut pas être vide !',
    roleRequired: 'Le rôle ne peut pas être vide !'
  },
  homepage: {
    totalIP: 'IP total',
    todayfc: 'Revenus d\'aujourd\'hui',
    weekQOQ: 'Comparaison hebdomadaire',
    dayQOQ: 'Comparaison quotidienne',
    todayCompanyIncome: 'Revenus du commerçant aujourd\'hui',
    todayPlatformIncome: 'Revenus de la plateforme aujourd\'hui',
    todayFlow: 'Flux de clients aujourd\'hui',
    todayOrder: 'Commandes aujourd\'hui',
    todayRefundOrder: 'Commandes de remboursement aujourd\'hui',
    machineOnlineCount: 'Machines en ligne',
    machineOfflineCount: 'Machines hors ligne',
    totalPlatformIncome: 'Revenus totaux de la plateforme',
    totalOperatorIncome: 'Commission totale de l\'opérateur',
    totalCompanyIncome: 'Revenus totaux du commerçant',
    totalFlow: 'Flux total de clients',
    totalOrder: 'Total des commandes',
    totalRefundOrder: 'Total des remboursements',
    usage: 'Utilisation',
    incomeAmount: 'Montant des revenus',
    flow: 'Flux',
    orderCount: 'Nombre de commandes',
    todayIncome: 'Revenus d\'aujourd\'hui',
    lastLoginTime: 'Dernière connexion',
    canWithdrawalIncome: 'Revenus retirables',
    goodMorning: 'Bonjour',
    goodForenoon: 'Bon matin',
    goodNoon: 'Bon midi',
    goodAfternoon: 'Bon après-midi',
    goodEvening: 'Bonsoir',
    welcome1: 'Prenez un café et reposez-vous ☕',
    welcome2: 'Voulez-vous jouer à LOL avec des amis?',
    welcome3: 'Voulez-vous jouer à Honor of Kings avec des amis?',
    welcome4: 'Vous êtes encore plus beau après quelques jours 😍',
    welcome5: 'Combien de bugs avez-vous écrits aujourd\'hui 🐞?',
    welcome6: 'Avez-vous discuté dans le groupe aujourd\'hui?',
    welcome7: 'Quel délicieux repas avez-vous mangé aujourd\'hui?',
    welcome8: 'Avez-vous souri aujourd\'hui 😊?',
    welcome9: 'Avez-vous aidé d\'autres personnes à résoudre des problèmes aujourd\'hui?',
    welcome10: 'Que allez-vous manger?',
    welcome11: 'Aller au cinéma ce week-end?',
    dateRange: '{start}~{end}',
    withdraw: 'Retirer',
    avatarAlt: 'Avatar',
    noDept: 'Pas de département',
    noRole: 'Pas de rôle',
    firstVisit: 'Première visite',
    todayIp: 'IP d\'aujourd\'hui',
    todayVisit: 'Visites d\'aujourd\'hui',
    totalVisit: 'Visites totales',
    lowPaperTitle: 'Alerte papier photo insuffisant',
    lowPaperTip: 'Les appareils suivants ont moins de {count} feuilles de papier photo restantes. Veuillez recharger le papier à temps pour ne pas affecter leur utilisation normale !',
    lowPaperDeviceName: 'Nom de l\'appareil',
    lowPaperDeviceCode: 'Code de l\'appareil',
    lowPaperCount: 'Quantité de papier',
    lowPaperClose: 'Fermer'
  },
  device: {
    companyManage: 'Gestion des commerçants',
    deviceManage: 'Gestion des appareils',
    totalDevices: 'Total des machines',
    all: 'Tous',
    online: 'En ligne',
    offline: 'Hors ligne',
    updating: 'Mise à jour',
    versionUpdate: 'Mise à jour de version',
    export: 'Exporter',
    batchUpdate: 'Mise à jour par lots',
    unbind: 'Délier',
    bind: 'Lier',
    companyName: 'Nom du commerçant',
    deviceCode: 'Code de l\'appareil',
    appVersion: 'Version de l\'application',
    sn: 'Numéro de série',
    uiName: 'Nom de l\'UI',
    uiGroupName: 'Groupe UI',
    photoTime: 'Temps de photo',
    intervalTime: 'Intervalle de temps',
    pagerNum: 'Nombre de pages',
    goodsNum: 'Nombre de produits',
    filterNum: 'Nombre de filtres',
    address: 'Adresse de la machine',
    orderCount: 'Nombre de commandes',
    operation: 'Opération',
    command: 'La commande a été envoyée avec succès',
    reset: 'Réinitialiser',
    restartApp: 'Redémarrer l\'application',
    showMenu: 'Afficher le menu',
    hideMenu: 'Masquer le menu',
    reportLog: 'Signaler le journal',
    isSupperCoins: 'Support pour pièces',
    unbinded: 'Délié',
    binded: 'Lié',
    bindStatus: 'Statut de liaison',
    lastestOnlineTime: 'Dernière fois en ligne',
    macAddress: 'Adresse MAC',
    resolution: 'Résolution',
    deviceSN: 'SN de l\'appareil',
    deviceVersion: 'Version de l\'appareil',
    deviceKey: 'Clé de l\'appareil',
    deviceIMEI: 'IMEI de l\'appareil',
    activationCode: 'Code d\'activation',
    leyaoyaoCode: 'Code Leyaoyao',
    electronicPhoto: 'Photo électronique',
    scanDownload: 'Scanner pour télécharger',
    sendFriend: 'Envoyer à un ami',
    templateImage: 'Image de modèle',
    working: 'En cours de travail',
    workStatus: 'Statut de travail',
    thumbnail: 'Miniature',
    remoteCode: 'Code distant',
    belongCategory: 'Catégorie',
    allMerchants: 'Tous les marchands',
    assign: 'Attribuer',
    viewOrders: 'Voir les commandes',
    selectBindMerchant: 'Veuillez sélectionner le marchand à lier',
    pendingVendorActive: 'Activation Shouqianba en attente',
    vendorActivationCode: 'Code d\'activation Shouqianba',
    vendorActivationCodePlaceholder: 'Veuillez saisir le code d\'activation Shouqianba',
    vendorActivationCodeRequired: 'Veuillez saisir le code d\'activation Shouqianba',
    merchantName: 'Nom du marchand',
    selectMerchantName: 'Veuillez sélectionner le nom du marchand',
    assignDeviceToSub: 'Attribuer l\'appareil au sous-marchand',
    deviceLabel: 'Appareil : ',
    targetMerchant: 'Marchand cible',
    selectSubMerchant: 'Veuillez sélectionner un sous-marchand',
    noSubMerchant: 'Aucun sous-marchand disponible, veuillez d\'abord créer un marchand de niveau 3',
    selectTargetMerchant: 'Veuillez sélectionner un marchand cible',
    assignSuccess: 'Appareil attribué avec succès',
    assignFailed: 'Échec de l\'attribution de l\'appareil',
    selectDeviceToUpdate: 'Veuillez sélectionner les appareils à mettre à jour ! Au moins un',
    setupSuccess: 'Configuration de l\'appareil réussie',
    updateUI: 'Mettre à jour l\'UI',
    updateApp: 'Mettre à jour l\'APP',
    updateConfig: 'Mettre à jour la configuration',
    shellExec: 'Exécution de commandes Shell',
    shellCommand: 'Commande Shell',
    shellCommandPlaceholder: 'Saisissez la commande Shell à exécuter, ex. : ls -la /tmp',
    sendShellCommand: 'Envoyer la commande Shell',
    dangerousConfirmTip: 'Les commandes dangereuses nécessitent une confirmation',
    notifiedUpdateUI: 'Appareil notifié pour mettre à jour l\'UI',
    notifiedUpdateApp: 'Appareil notifié pour mettre à jour l\'APP',
    notifiedUpdateConfig: 'Appareil notifié pour mettre à jour la configuration',
    inputShellCommand: 'Veuillez saisir une commande Shell',
    dangerousWarningTitle: '⚠️ Avertissement d\'opération dangereuse',
    dangerousWarningContent: 'Vous exécutez une commande dangereuse qui peut provoquer des anomalies de l\'appareil ! Continuer ?',
    confirmExecute: 'Confirmer l\'exécution',
    commandSent: 'Commande envoyée, veuillez attendre l\'exécution par l\'appareil',
    sendFailed: 'Échec de l\'envoi',
    networkError: 'Erreur réseau, veuillez réessayer plus tard',
    confirmUnbind: 'Après la dissociation, l\'appareil sera dissocié du commerçant. Voulez-vous vraiment dissocier cet appareil ?',
    copyCompanyName: 'Copier le nom du commerçant',
    copyDeviceCode: 'Copier le code de l\'appareil',
    copyActiveCode: 'Copier le code d\'activation',
    copySuccess: 'Copie réussie',
    copyFail: 'Échec de la copie'
  },
  setting: {
    navbarColor: 'Couleur de la barre de navigation',
    themeColor: 'Couleur du thème',
    navbarPosition: 'Position de la barre de navigation',
    fixedTopRail: 'Fixer la barre supérieure',
    fixedSidebar: 'Fixer la barre latérale',
    multiTabMode: 'Mode multi-onglets',
    languageSwitching: 'Changer de langue',
    userCenter: 'Centre utilisateur',
    updatePassword: 'Mettre à jour le mot de passe',
    customSystem: 'Personnaliser le système',
    logout: 'Déconnexion',
    updateCache: 'Mettre à jour le cache',
    refreshCacheSuccess: 'Cache mis à jour avec succès',
    refreshCacheFailed: 'Échec de la mise à jour du cache'
  },
  common: {
    confirm: 'Confirmer',
    cancel: 'Annuler',
    saveSetting: 'Enregistrer les paramètres',
    languageChanged: 'Langue changée avec succès',
    timezoneChanged: 'Fuseau horaire changé avec succès',
    search: 'Rechercher',
    pleaseInputContent: 'Veuillez entrer le contenu',
    export: 'Exporter',
    default: 'Par défaut',
    item: 'Élément',
    view: 'Voir',
    setup: 'Configuration',
    status: 'Statut',
    showTotal: 'Affichage de {start} ~ {end} enregistrements, total {total} enregistrements',
    yes: 'Oui',
    no: 'Non',
    info: 'Information',
    sequenceNumber: 'Nº',
    creationTime: 'Date de création',
    operation: 'Opération',
    defaultSort: 'Numéro d\'ordre',
    type: 'Intégré',
    edit: 'Modifier',
    delete: 'Supprimer',
    deleteSuccess: 'Supprimé avec succès',
    editSuccess: 'Modifié avec succès',
    updateSuccess: 'Mis à jour avec succès',
    connectionError: 'Connexion au serveur anormale, veuillez réessayer plus tard!',
    reset: 'Réinitialiser',
    allCategory: 'Toutes les catégories',
    query: 'Requête',
    add: 'Ajouter',
    loadError: 'Erreur de chargement',
    isDefault: 'Par défaut',
    setDefault: 'Définir comme par défaut',
    cancelDefault: 'Annuler par défaut',
    batchEdit: 'Modification par lots',
    back: 'Retour',
    uploadImg: 'Télécharger une image',
    uploadImgSuccess: 'Image téléchargée avec succès',
    uploadImgFailed: 'Échec du téléchargement',
    uploadImgTips1: 'Seuls les formats JPG, JPEG, GIF, PNG sont autorisés',
    uploadImgTips2: 'Le fichier dépasse la limite de 10M, téléchargement non autorisé',
    addSuccess: 'Ajouté avec succès',
    all: 'Tout',
    batchAdd: 'Ajout par lots',
    deleteError: 'Échec de la suppression',
    deleteNoData: 'Veuillez sélectionner les données à supprimer',
    disable: 'Désactivé',
    enable: 'Activé',
    exportError: 'Échec de l’exportation !',
    exportExecl: 'Exporter Excel',
    exportSuccess: 'Exportation réussie',
    noData: 'Aucune donnée',
    operateError: 'Opération échouée, veuillez réessayer',
    prompt: 'Conseils',
    searchError: 'Échec de la recherche',
    selectDataFirst: 'Veuillez d’abord sélectionner les autocollants à exporter !',
    uploadError: 'Échec du téléchargement',
    selectAll: 'Tout sélectionner',
    totalRecords: '{total} enregistrements au total',
    closeLeft: 'Fermer à gauche',
    closeRight: 'Fermer à droite',
    closeOthers: 'Fermer les autres'
  },
  template: {
    merchantManagement: 'Commerçant',
    uiManagement: 'UI',
    newConfig: 'Nouveau cadre',
    editFrame: 'Modifier le cadre',
    editConfig: 'Modifier la configuration',
    top: 'Haut',
    bottom: 'Bas',
    builtIn: 'Intégré',
    nonBuiltIn: 'Non intégré',
    uiConfigName: 'Nom',
    background: 'Arrière-plan',
    wechatOfficialAccount: 'Code QR',
    title: 'Titre',
    banner: 'Bannière',
    creationTime: 'Date de création',
    indicatorColor: 'Couleur de l\'indicateur',
    type: 'Type',
    appliedMachines: 'Machines appliquées',
    freamName: 'Nom du cadre',
    editSuccess: 'UI modifiée avec succès',
    tip: 'Conseil',
    deletePrompt: 'La suppression de cette configuration UI empêchera l\'utilisateur de l\'utiliser. Êtes-vous sûr de vouloir la supprimer?',
    matchProduct: 'Associer le produit',
    selectProduct: 'Veuillez sélectionner un produit',
    templateFilePng: 'Fichier de modèle PNG',
    maxFileSize: 'La taille maximale du fichier est de 10M',
    addUploadImage: 'Ajouter une image téléchargée',
    addHistoryImage: 'Sélectionner une image historique',
    previewImage: 'Aperçu',
    cuttingImage: 'Image de découpe',
    groupPhotoFrame: 'Cadre photo de groupe',
    groupPhotoYes: 'Photo de groupe',
    groupPhotoNo: 'Pas de photo de groupe',
    groupPhotoLensSetting: 'Configurer les détails d\'objectif de groupe',
    groupPhotoConfigured: 'Photo de groupe configurée',
    groupPhotoNotSet: 'Photo de groupe non définie',
    buttonNormal: 'Bouton normal',
    buttonPressed: 'Bouton pressé',
    buttonNormalExample: 'Exemple de bouton normal',
    buttonPressedExample: 'Exemple de bouton appuyé',
    reuseTemplateFile: 'Réutiliser le fichier modèle',
    reuseNormalButton: 'Réutiliser le bouton normal',
    reuseAllTemplateFiles: 'Réutiliser tous les fichiers modèles',
    productType: 'Type de produit',
    stickerPreview: 'Aperçu de l\'autocollant',
    stickerCode: 'Code de l\'autocollant',
    stickerCategory: 'Catégorie',
    stickerType: 'Type',
    stickerSize: 'Taille',
    stickerStatus: 'Statut',
    stickerOperation: 'Opération',
    stickerName: 'Nom de l\'autocollant',
    addSticker: 'Ajouter un autocollant',
    editSticker: 'Modifier l’autocollant',
    StickerIndexNum: 'Numéro d’ordre',
    onlyImage: 'Seules les images JPG, JPEG, GIF et PNG peuvent être téléchargées',
    selectCategory: 'Veuillez sélectionner une catégorie',
    selectStatus: 'Veuillez sélectionner le statut',
    selectType: 'Veuillez sélectionner le type',
    stickerFileSize: 'Taille du fichier',
    staticSticker: 'Autocollant statique',
    gifSticker: 'Animation GIF',
    videoSticker: 'Autocollant vidéo',
    frameGroup: 'Groupe de cadres'
  },
  sticker: {
    stickerPreview: 'Image de l\'autocollant',
    stickerCode: 'Code de l\'autocollant',
    stickerCategory: 'Catégorie',
    stickerType: 'Type',
    stickerSize: 'Taille',
    stickerStatus: 'Statut',
    stickerOperation: 'Opération',
    stickerName: 'Nom de l\'autocollant',
    stickerImage: 'Image de l\'autocollant',
    stickerThumbnail: 'Miniature',
    stickerWidth: 'Largeur (pixels)',
    stickerHeight: 'Hauteur (pixels)',
    stickerDuration: 'Durée du fichier (secondes)',
    stickerFileSize: 'Taille du fichier',
    StickerIndexNum: 'Numéro d\'ordre',
    stickerTags: 'Mots-clés',
    stickerDescription: 'Description',
    statusTips: 'Veuillez sélectionner le statut',
    typeTips: 'Veuillez sélectionner le type',
    categoryTips: 'Veuillez sélectionner la catégorie',
    editSticker: 'Modifier l\'autocollant',
    imgPreview: 'Aperçu de l\'image',
    codeCheckResultErr: '❌ Ce code existe déjà, veuillez le changer',
    codeCheckResultOk: '✅ Code disponible',
    inputCodeTips: 'Facultatif. Les appareils distinguent le type d\'autocollant par le suffixe du code (ex. : ST2D). Lettres majuscules, chiffres et tirets bas recommandés',
    addSticker: 'Ajouter un autocollant',
    categoryIcon: 'Icône de catégorie',
    categoryName: 'Nom de la catégorie',
    categoryCode: 'Code de la catégorie',
    categoryIconPlaceholder: 'Veuillez entrer l\'URL de l\'icône',
    addCategory: 'Ajouter une catégorie',
    editCategory: 'Modifier la catégorie',
    groupNewAdd: 'Nouveau groupe',
    groupEdit: 'Modifier le groupe',
    groupName: 'Nom du groupe',
    groupCode: 'Code du groupe',
    groupIcon: 'Icône du groupe',
    hasSticker: 'Nombre d\'autocollants',
    groupCodePlaceholder: 'Veuillez entrer le code du groupe (lettres majuscules)',
    groupNamePlaceholder: 'Veuillez entrer le nom du groupe',
    groupDescriptionPHR: 'Veuillez entrer la description du groupe',
    controllerSticker: 'Gérer les autocollants',
    selectSticker: 'Sélectionner un autocollant',
    addFailed: 'Échec de l’ajout',
    addSuccess: 'Ajouté avec succès',
    deleteFailed: 'Échec de la suppression',
    deleteSuccess: 'Supprimé avec succès',
    fileDurationDesc: 'Vidéo/GIF uniquement, facultatif',
    fileDurationTips: 'Requis uniquement pour les autocollants vidéo/GIF',
    fileSizeDesc: 'Rempli automatiquement après le téléchargement',
    fileSizeExample: 'ex. : 51200',
    heightExample: 'ex. : 200',
    widthExample: 'ex. : 200',
    selectAtLeastOne: 'Veuillez sélectionner au moins un autocollant',
    stickerCodeDesc: 'Identifiant unique global, format STICKER_XXX recommandé',
    stickerCodeTips: 'Veuillez saisir le code de l’autocollant (unique)',
    stickerImageSize: 'Taille recommandée : 200x200 pixels, formats PNG, JPG pris en charge',
    thumbnail: 'Miniature',
    uploadStickerImage: 'Veuillez télécharger l’image de l’autocollant',
    confirmDeleteSticker: 'Êtes-vous sûr de supprimer cet autocollant?',
    stickerSlected: 'Autocollants sélectionnés',
    inputStickerName: 'Veuillez saisir le nom de l\'autocollant',
    inputStickerCode: 'Veuillez saisir le code de l\'autocollant',
    codeFormatTips: 'Le format STICKER_XXX est recommandé',
    codeExists: 'Ce code d\'autocollant existe déjà, veuillez le modifier',
    codeValidateFailed: 'Échec de la validation',
    codeValidateError: 'Échec de la validation du code, veuillez réessayer',
    codeFormatError: 'Format de code invalide, le format STICKER_XXX est recommandé',
    codeCheckFailedRetry: 'Échec de la validation, veuillez réessayer',
    tagsPlaceholder: 'Séparez plusieurs tags par des virgules, ex. : heureux, emoji, sourire',
    tagsDesc: 'Utilisé pour la recherche et la catégorisation',
    descPlaceholder: 'Veuillez saisir la description de l\'autocollant',
    uploadImage: 'Télécharger une image',
    uploadThumbnail: 'Télécharger une miniature',
    reuseStickerImage: "Réutiliser l'image du sticker",
    reuseStickerImageTip: "La miniature utilisera directement l'image du sticker, aucun téléversement séparé requis",
    thumbnailOptional: 'Facultatif, peut être généré automatiquement par le système',
    thumbnailUploadSuccess: 'Miniature téléchargée avec succès',
    selectCategoryAttr: 'Veuillez sélectionner une catégorie',
    completeFormInfo: 'Veuillez remplir les champs obligatoires du formulaire',
    sortOrderPlaceholder: 'Plus le numéro est petit, plus il est en haut',
    categoryCodePlaceholder: 'Veuillez saisir le code de catégorie (majuscules)',
    categoryCodeDesc: 'Identifiant unique, les majuscules sont recommandées, ex. : HOT, CUTE',
    inputCategoryName: 'Veuillez saisir le nom de la catégorie',
    inputCategoryCode: 'Veuillez saisir le code de catégorie',
    categoryCodePatternMsg: 'Veuillez saisir des majuscules, les underscores sont autorisés',
    categoryCodeExists: 'Ce code de catégorie existe déjà, veuillez le modifier',
    uploadCategoryIcon: 'Veuillez télécharger l\'icône de catégorie',
    sortOrderMustNumber: 'L\'ordre de tri doit être un nombre',
    categoryDescPlaceholder: 'Veuillez saisir la description de la catégorie',
    confirmDeleteCategory: 'Confirmer la suppression de cette catégorie ?',
    exportDeveloping: 'La fonction d\'exportation est en cours de développement...',
    confirmDeleteGroup: 'Êtes-vous sûr de supprimer ce groupe ?',
    selectGroupToDelete: 'Veuillez sélectionner le groupe à supprimer',
    inputGroupName: 'Veuillez saisir le nom du groupe',
    groupNameTooLong: 'Le nom du groupe ne peut pas dépasser 50 caractères',
    inputGroupCode: 'Veuillez saisir le code du groupe',
    groupCodeFormatMsg: 'Le code du groupe ne peut contenir que des majuscules, des chiffres et des underscores',
    groupCodeTooLong: 'Le code du groupe ne peut pas dépasser 50 caractères',
    groupCodeInvalidOrExists: 'Le format du code du groupe est invalide ou existe déjà, veuillez vérifier',
    uploadGroupIcon: 'Veuillez télécharger l\'icône du groupe',
    sortOrderInvalid: 'Veuillez saisir un ordre de tri valide (nombre >= 0)',
    selectStatusEnableDisable: 'Veuillez sélectionner un statut (Activé/Désactivé)',
    codeCheckErrorTips: '⚠️ Échec de la validation du code, veuillez réessayer plus tard',
    editFailed: 'Échec de la modification',
    operationFailedRetry: 'Opération échouée, veuillez réessayer',
    apiException: 'Erreur système',
    selectStickerType: 'Veuillez sélectionner le type d\'autocollant'
  },
  filter: {
    filterName: 'Nom du filtre',
    addFilter: '+ Ajouter un filtre',
    addFilterTitle: 'Ajouter un filtre',
    editFilterTitle: 'Modifier le filtre',
    filterPreview: 'Aperçu du filtre',
    filterOriginalImage: 'Image d\'origine du filtre',
    filterResourceFile: 'Fichier de ressources du filtre',
    belongCompany: 'Marchand',
    allMerchants: 'Tous les marchands',
    type: 'Type',
    builtIn: 'Intégré',
    nonBuiltIn: 'Non intégré',
    appliedMachines: 'Machines appliquées',
    defaultSort: 'Ordre de tri',
    serialNo: 'N°',
    batchCopy: 'Copie par lot',
    copy: 'Copier',
    tip: 'Astuce',
    deletePrompt: 'La suppression de ce filtre rendra les machines incapables de l\'utiliser. Voulez-vous vraiment le supprimer ?',
    editFilterSuccess: 'Filtre modifié avec succès',
    loadCompanyFailed: 'Échec du chargement de la liste des marchands',
    copyFilterSuccess: 'Filtre copié avec succès',
    copyFilterFailed: 'Échec de la copie du filtre',
    batchCopySuccess: 'Filtres copiés avec succès',
    batchCopyFailed: 'Échec de la copie par lot',
    selectFilterFirst: 'Veuillez d\'abord sélectionner les filtres à copier',
    copyToMerchantTitle: 'Copier le filtre vers un marchand',
    batchCopyTitle: 'Copier les filtres par lot vers un marchand',
    originalFilterName: 'Nom du filtre d\'origine',
    newFilterName: 'Nouveau nom du filtre',
    inputNewFilterName: 'Veuillez saisir le nouveau nom du filtre',
    targetMerchant: 'Marchand cible',
    selectCompany: 'Veuillez sélectionner un marchand',
    selectedFilters: 'Filtres sélectionnés',
    nameSuffix: 'Suffixe de nom commun',
    inputNameSuffix: 'Veuillez saisir le suffixe de nom commun',
    nameSuffixTip: 'Nouveau nom = nom d\'origine + ce suffixe',
    inputFilterName: 'Veuillez saisir le nom du filtre',
    inputName: 'Veuillez saisir un nom',
    selectTypeMsg: 'Veuillez sélectionner un type',
    inputDefaultSort: 'Veuillez saisir l\'ordre de tri',
    colorMatrix: 'Matrice de couleurs',
    whitening: 'Blanchiment',
    smoothing: 'Lissage de la peau',
    bigEye: 'Grands yeux',
    thinFace: 'Visage fin',
    smallFace: 'Petit visage',
    forehead: 'Front',
    cheekbone: 'Pommettes',
    nose: 'Nez',
    mouth: 'Bouche',
    chin: 'Menton',
    intensity: 'Intensité du filtre',
    sampleFullColor: 'Exemple couleur :',
    colorModeExample: 'Exemple du mode couleur',
    pngFilterExample: 'Exemple PNG d\'origine du filtre',
    anyFormatMax10M: 'Tout format, jusqu\'à 10 Mo',
    colorModeNormal: 'Mode couleur - Normal :',
    colorModePressed: 'Mode couleur - Appuyé :',
    reuseAllSampleColor: 'Réutiliser l\'exemple couleur pour tous',
    addUploadImage: 'Ajouter et téléverser une image',
    uploadFile: 'Téléverser un fichier',
    reupload: 'Téléverser à nouveau',
    submit: 'Soumettre',
    btnNormalRequired: 'L\'image « Mode couleur - Normal » ne peut pas être vide !',
    imageUrlRequired: 'L\'image d\'exemple couleur ne peut pas être vide !',
    filterPngRequired: 'L\'image d\'origine du filtre ne peut pas être vide !',
    btnSelectedRequired: 'L\'image « Mode couleur - Appuyé » ne peut pas être vide !',
    exceed10M: 'Limite de 10 Mo dépassée, téléversement non autorisé~',
    uploadFailed: 'Échec du téléversement'
  },
  goods: {
    productName: 'Nom du produit',
    newProductName: 'Nouveau nom du produit',
    productCode: 'Code du produit',
    preview: 'Aperçu',
    width: 'Largeur',
    height: 'Hauteur',
    imageCount: 'Nombre d\'images',
    frameTop: 'Distance depuis le haut',
    frameBottom: 'Distance depuis le bas',
    frameLeft: 'Distance depuis la gauche',
    frameRight: 'Distance depuis la droite',
    frameCount: 'Quantité de cadres',
    printMode: 'Mode d\'impression',
    orientation: 'Direction d\'impression',
    price: 'Prix unitaire',
    companyPrice: 'Prix du commerçant',
    increasePrice: 'Prix d\'impression supplémentaire',
    defaultIncreasePrice: 'Prix d\'impression supplémentaire par défaut',
    companyIncreasePrice: 'Prix d\'impression supplémentaire du commerçant',
    type: 'Type',
    deviceCount: 'Nombre de machines appliquées',
    operation: 'Opération',
    tip: 'Conseil',
    confirmDelete: 'Après la suppression, les machines ne pourront plus sélectionner ce produit. Êtes-vous sûr de le supprimer?',
    view: 'Voir',
    edit: 'Modifier',
    delete: 'Supprimer',
    search: 'Rechercher',
    addProduct: '+ Ajouter un produit',
    pleaseInputContent: 'Veuillez entrer le contenu de recherche',
    sequenceNumber: 'Nº',
    printingMode: 'Mode d\'impression',
    oneCopyInDuplicate: 'Une copie',
    inDuplicate: 'Mode d\'impression',
    vertical: 'Vertical',
    horizontal: 'Horizontal',
    riceConfirmation: 'Veuillez entrer le prix correct! Ne peut être supérieur ou égal à 0.01',
    cannotEditBuiltIn: 'Les produits intégrés ne peuvent pas être modifiés, seul le superadministrateur peut les modifier',
    cannotDeleteBuiltIn: 'Les produits intégrés ne peuvent pas être supprimés, seul le superadministrateur peut les supprimer',
    copy: 'Copier',
    copyProduct: 'Copier le produit',
    originalProductName: 'Nom du produit original',
    inputProductName: 'Veuillez entrer le nom du nouveau produit',
    selectCompany: 'Veuillez sélectionner un commerçant',
    copySuccess: 'Produit copié avec succès',
    frameManage: 'Gestion des cadres',
    orderNum: 'Ordre de tri',
    belongCategory: 'Catégorie',
    belongCompany: 'Marchand',
    subCategory: 'Sous-catégorie',
    groupName: 'Nom du groupe'
  },
  order: {
    orderManagement: 'Gestion des commandes',
    orderList: 'Liste des commandes',
    all: 'Tous',
    paid: 'Payé',
    completed: 'Terminé',
    unpaid: 'Non payé',
    refunded: 'Remboursé',
    timeout: 'Délai dépassé',
    canceled: 'Annulé',
    paying: 'En cours de paiement',
    unclose: 'Non fermé',
    closed: 'Fermé',
    toBeReversed: 'À inverser',
    reversed: 'Inversé',
    evaluated: 'Évalué',
    exception: 'Exception',
    unknown: 'Inconnu',
    payFail: 'Échec du paiement',
    notRefund: 'N/A',
    applyRefund: 'Demander un remboursement',
    refundInProgress: 'Remboursement en cours',
    agreeRefund: 'Accepter le remboursement',
    refuseRefund: 'Refuser le remboursement',
    refundedStatus: 'Remboursement terminé',
    refundFail: 'Échec du remboursement',
    cancelRefund: 'Annuler le remboursement',
    photo: 'Photo',
    print: 'Imprimer',
    remotePrint: 'Impression \u00e0 distance',
    viewRemotePhotos: 'Voir les photos',
    remotePrintPhotos: 'Photos d\'impression \u00e0 distance',
    uploadPhotos: 'Photos téléversées',
    uploadPrint: 'Télécharger et imprimer',
    noPhotos: 'Aucune photo',
    orderNumber: 'Numéro de commande',
    merchant: 'Commerçant correspondant',
    deviceNumber: 'Numéro de machine',
    payMode: 'Mode de paiement',
    orderType: 'Type de commande',
    paymentStatus: 'Statut de paiement',
    totalPrice: 'Prix total',
    createTime: 'Date de création',
    payTime: 'Date de paiement',
    quantity: 'Quantité',
    unitPrice: 'Prix unitaire',
    discountAmount: 'Montant de la remise',
    refundStatus: 'Statut de remboursement',
    refundReason: 'Note de commande',
    operation: 'Opération',
    export: 'Exporter',
    orderCount: 'Nombre de commandes',
    searchPlaceholder: 'Veuillez entrer le contenu de recherche',
    agree: 'Accepter le remboursement',
    refuse: 'Refuser le remboursement',
    refund: 'Remboursement',
    viewPhoto: 'Voir les photos',
    gifImage: 'GIF animé',
    confirmAgreeRefund: 'Accepter la demande de remboursement de cette commande?',
    agreeRefundContent: 'Après avoir cliqué sur OK, cette commande terminera la demande de remboursement',
    agreeRefundSuccess: 'Demande de remboursement acceptée avec succès',
    confirmRefuseRefund: 'Refuser la demande de remboursement de cette commande?',
    refuseRefundContent: 'Après avoir cliqué sur OK, cette commande refusera la demande de remboursement',
    refuseRefundSuccess: 'Demande de remboursement refusée avec succès',
    deviceName: 'Nom de la machine',
    viewPhotos: 'Détails des photos',
    photoDetail: 'Détails des photos',
    compositePhotos: 'Photos composites',
    originalPhotos: 'Photos originales',
    noCompositePhotos: 'Aucune photo composite',
    noOriginalPhotos: 'Aucune photo originale',
    frameId: 'ID du cadre',
    copyOrderCode: 'Copier le code de commande',
    allMerchants: 'Tous les marchands',
    allDevices: 'Tous les appareils',
    allPayModes: 'Tous les modes de paiement',
    payWeixin: 'WeChat',
    payAlipay: 'Alipay',
    payShouqianba: 'Shouqianba',
    payDougong: 'Dougong',
    payYunguanjia: 'Cloud Manager',
    payLeyaoyao: 'Leyaoyao',
    payCoins: 'Pièce',
    payFree: 'Gratuit',
    payCoupon: "Code d'échange",
    payDai: 'Jeton',
    payCoin: 'Paiement pièce',
    payCash: 'Espèces',
    payCard: 'Carte',
    copySuccess: 'Copie réussie',
    copyFail: 'Échec de la copie'
  },
  coupon: {
    all: 'Tous',
    notActivated: 'Non activé',
    activated: 'Activé',
    used: 'Utilisé',
    cancelled: 'Annulé',
    searchPlaceholder: 'Veuillez entrer le code du coupon/nom du commerçant/nom de l\'appareil',
    export: 'Exporter',
    generateCoupon: 'Générer un coupon',
    qrCode: 'Code QR',
    noQrCode: 'Aucun',
    clickToPreview: 'Cliquez pour voir l\'aperçu',
    couponQrCode: 'Code QR du coupon',
    clickToDownload: 'Cliquez sur l\'image pour télécharger directement',
    confirmCouponInfo: 'Veuillez confirmer les informations du coupon',
    merchantName: 'Nom du commerçant',
    selectMerchant: 'Veuillez sélectionner le nom du commerçant',
    deviceObject: 'Objet de l\'appareil',
    selectDeviceFirst: 'Veuillez d\'abord sélectionner l\'appareil',
    couponQuantity: 'Quantité de coupons',
    inputCouponQuantity: 'Veuillez entrer la quantité de coupons',
    activateCoupon: 'Activer le coupon?',
    yes: 'Oui',
    no: 'Non',
    activate: 'Activer',
    cancel: 'Annuler',
    couponId: 'Numéro de coupon',
    merchant: 'Nom du commerçant',
    deviceName: 'Nom de l\'appareil',
    couponCode: 'Code de coupon',
    status: 'Statut',
    createTime: 'Date de génération',
    operation: 'Opération',
    activateSuccess: 'Activé avec succès!',
    activateFailed: 'Échec de l\'activation!',
    cancelSuccess: 'Annulé avec succès!',
    cancelFailed: 'Échec de l\'annulation!',
    generateSuccess: 'Généré avec succès!',
    generateFailed: 'Échec de la génération!',
    generating: 'Génération des coupons en cours, veuillez patienter...',
    maxCouponLimit: 'Impossible de générer plus de 500 coupons à la fois!',
    generateTip: 'Un maximum de 500 coupons peuvent être générés à la fois. Veuillez générer par lots si nécessaire. Chaque machine peut générer jusqu\'à 2000 coupons par mois.',
    selectMerchantFirst: 'Veuillez d\'abord sélectionner un commerçant!',
    downloadSuccess: 'Téléchargé avec succès!'
  },
  dashboard: {
    date: 'Date',
    flow: 'Nombre de clients',
    companyCount: 'Nombre de nouveaux commerçants',
    deviceCount: 'Nombre de nouvelles machines',
    photoCount: 'Nombre de commandes de photos',
    printCount: 'Nombre de commandes d\'impression',
    amount: 'Revenus totaux de la plateforme',
    justSumAmount: 'Commission de la plateforme',
    companySumAmount: 'Commission du commerçant',
    lineCount: 'Nombre de machines en ligne',
    companyName: 'Nom du commerçant',
    deviceCode: 'Code de la machine',
    activeCode: 'Code de la machine',
    deviceName: 'Nom de la machine',
    photo: 'Nombre de commandes de photos',
    print: 'Nombre de commandes d\'impression',
    totalPrice: 'Revenus totaux de la plateforme',
    timeCycle: 'Temps',
    defaultTimeFilter: 'Filtre de temps par défaut (mois)',
    month: 'Mois',
    week: 'Semaine',
    day: 'Jour',
    search: 'Rechercher',
    export: 'Exporter',
    refund: 'Remboursement',
    confirmRefund: 'Demander un remboursement pour cette commande?',
    refundContent: 'Après avoir cliqué sur OK, cette commande lancera une demande de remboursement',
    refundSuccess: 'Demande de remboursement de la commande réussie',
    confirmAgreeRefund: 'Accepter la demande de remboursement de cette commande?',
    agreeRefundContent: 'Après avoir cliqué sur OK, cette commande terminera la demande de remboursement',
    agreeRefundSuccess: 'Demande de remboursement acceptée avec succès',
    confirmRefuseRefund: 'Refuser la demande de remboursement de cette commande?',
    refuseRefundContent: 'Après avoir cliqué sur OK, cette commande refusera la demande de remboursement',
    refuseRefundSuccess: 'Demande de remboursement refusée avec succès',
    timeRangeRequired: 'La plage de temps ne peut pas être vide'
  },
  uiGroup: {
    uiGroupManage: 'Gestion des groupes UI',
    newUIGroup: 'Nouveau groupe UI',
    searchUIName: 'Rechercher le nom du groupe UI...',
    resourceType: 'Type de ressource',
    adminDefine: 'Défini par Admin',
    merchantDefine: 'Défini par le commerçant',
    uiName: 'Nom de l\'UI',
    subPageCount: 'Nombre de sous-pages',
    downloadPackage: 'Télécharger le paquet',
    onlyOneInCategoryCannotDelete: 'Un seul groupe d\'interface dans cette catégorie (langue + produit), suppression impossible',
    remark: 'Remarque',
    createTime: 'Date de création',
    pageManage: 'Gestion des pages',
    copy: 'Copier',
    copyPrompt: 'Êtes-vous sûr de copier ce groupe UI?',
    copySuccess: 'Copié avec succès',
    copyFail: 'Échec de la copie',
    copyUIGroup: 'Copier le groupe UI',
    originalUIName: 'Nom du groupe UI original',
    newUIName: 'Nouveau nom du groupe UI',
    inputNewUIName: 'Veuillez entrer le nouveau nom du groupe UI',
    selectCompany: 'Veuillez sélectionner un commerçant',
    companyName: 'Nom du commerçant',
    addUIGroup: 'Nouveau groupe UI',
    deletePrompt: 'Êtes-vous sûr de supprimer ce groupe UI?',
    deleteSuccess: 'Supprimé avec succès',
    editUIGroup: 'Modifier le groupe UI',
    editSuccess: 'Modifié avec succès',
    addSuccess: 'Groupe UI ajouté avec succès',
    addFail: 'Échec de l\'ajout du groupe UI',
    newPage: 'Nouvelle page',
    editPage: 'Modifier la page',
    addPage: 'Ajouter une page',
    pageName: 'Nom de la page',
    pageKey: 'Clé de la page',
    pageOrder: 'Ordre de la page',
    elementCount: 'Nombre d\'éléments',
    elementManage: 'Gestion des éléments',
    pleaseInputPageName: 'Veuillez entrer le nom de la page',
    pleaseInputPageKey: 'Veuillez entrer la clé de la page',
    pleaseInputPageOrder: 'Veuillez entrer l\'ordre de la page',
    deletePagePrompt: 'Êtes-vous sûr de supprimer cette page? Impossible de récupérer après suppression!',
    addPageSuccess: 'Page ajoutée avec succès',
    addPageFail: 'Échec de l\'ajout de la page',
    editPageSuccess: 'Page modifiée avec succès',
    editPageFail: 'Échec de la modification de la page',
    deletePageSuccess: 'Page supprimée avec succès',
    deletePageFail: 'Échec de la suppression de la page',
    pageKeyExists: 'La clé de la page existe déjà, veuillez la changer',
    productType: 'Type de produit',
    elementName: 'Nom de l\'élément',
    elementType: 'Type d\'élément',
    allElement: 'Tous les éléments',
    editElement: 'Modifier l\'élément',
    addElement: 'Ajouter un élément',
    elementValue: 'Valeur de l\'élément',
    elementValueMsg: 'Veuillez entrer la valeur de l\'élément',
    elementKey: 'Clé de l\'élément',
    elementKeyMsg: 'Veuillez entrer la clé de l\'élément',
    elementKeyPlaceholder: 'La clé de l\'élément ne peut pas être dupliquée dans la même page, il est recommandé d\'utiliser des lettres et des traits de soulignement',
    elementNameMsg: 'Veuillez entrer le nom de l\'élément',
    elementTypeMsg: 'Veuillez sélectionner le type d\'élément',
    elementKeyError: 'La clé de l\'élément existe déjà dans la page actuelle, veuillez la changer',
    elemnetDeleteTips: 'Êtes-vous sûr de supprimer cet élément?',
    batchEditElement: 'Modification d\'éléments par lots',
    horizontalLayout: 'Disposition horizontale',
    verticalLayout: 'Disposition verticale',
    loadingElementList: 'Chargement de la liste des éléments...',
    allResourceType: 'Tous les types de ressources',
    pleaseInputUIName: 'Veuillez entrer le nom du groupe UI',
    pleaseSelectResourceType: 'Veuillez sélectionner le type de ressource',
    previewImage: 'Image d\'aperçu',
    reupload: 'Téléverser à nouveau',
    uploadPreviewImage: 'Téléverser l\'aperçu',
    languageType: 'Langue',
    selectLanguageType: 'Veuillez sélectionner la langue',
    pageSize: 'Taille de la page',
    pixelWH: 'Pixels (L×H)',
    belongCompany: 'Marchand',
    cancelDefaultConfirm: 'Êtes-vous sûr de vouloir annuler le statut par défaut de ce groupe d\'UI ?',
    setDefaultConfirm: 'Êtes-vous sûr de vouloir définir ce groupe d\'UI comme par défaut ?',
    operateSuccess: 'Opération réussie !',
    operateFail: 'Échec de l\'opération',
    onlyJpgPng: 'Seules les images JPG et PNG peuvent être téléversées !',
    exceed4M: 'La taille de l\'image ne peut pas dépasser 4 Mo !',
    uploadSuccess: 'Téléversement réussi',
    uploadSuccessNoUrl: 'Téléversement réussi mais impossible d\'obtenir l\'URL de l\'image',
    inputImageUrlPlaceholder: 'Ou saisissez directement une URL d\'image (http/https)',
    useImageUrl: 'Utiliser cette URL',
    invalidImageUrl: 'Veuillez saisir une URL d\'image valide (commençant par http:// ou https://)',
    imageUrlApplied: 'URL de l\'image appliquée',
    pasteTip: 'Astuce : après avoir copié une image ou fait une capture d\'écran, appuyez sur Ctrl+V/Cmd+V pour la coller et la téléverser',
    pasteUploadSuccess: 'Image collée téléversée avec succès',
    langZhCN: 'Chinois simplifié',
    langEn: 'Anglais',
    langFr: 'Français',
    langKo: 'Coréen',
    langZhTW: 'Chinois traditionnel',
    langVi: 'Vietnamien',
    langAr: 'Arabe',
    langBih: 'Bosnien',
    langTh: 'Thaï',
    langDe: 'Allemand',
    langEs: 'Espagnol'
  },
  deviceSetup: {
    title: 'Configuration de l\'appareil',
    basicInfo: 'Informations de base',
    machineModelSN: 'Modèle de machine [SN]',
    inputMachineSN: 'Veuillez entrer le code SN de la machine',
    machineName: 'Nom de la machine',
    inputMachineName: 'Veuillez entrer le nom de la machine',
    machineCode: 'Code de la machine',
    inputMachineCode: 'Veuillez entrer le code de la machine',
    machineAddress: 'Adresse de la machine',
    inputMachineAddress: 'Veuillez entrer l\'adresse de la machine',
    activationCode: 'Code d\'activation',
    h5Url: 'URL de la page H5',
    parseUrl: 'Analyser l\'URL',
    urlEditorTitle: 'Gestion des paramètres d\'URL H5',
    urlBase: 'URL de base',
    urlParams: 'Paramètres d\'URL',
    paramName: 'Nom du paramètre',
    paramValue: 'Valeur du paramètre',
    addParam: 'Ajouter un paramètre',
    noParams: 'Aucun paramètre. Cliquez sur « Ajouter un paramètre »',
    done: 'Terminé',
    pasteTip: 'Astuce : après avoir copié une image ou fait une capture d’écran, appuyez sur Ctrl+V pour la coller et la télécharger',
    pasteUploadSuccess: 'Image collée téléchargée avec succès',
    filterByCompany: 'Filtrer par marchand',
    customerServicePhone: 'Téléphone du service client',
    photoAccessType: 'Méthode d\'accès aux photos',
    selectPhotoAccessType: 'Veuillez sélectionner le type',
    paymentMode: 'Mode de paiement',
    selectPaymentMode: 'Veuillez sélectionner le type',
    onlinePayment: 'Paiement en ligne',
    offlineCoin: 'Pièce physique',
    scanQRCode: 'Scanner le code QR',
    addFriend: 'Ajouter un ami',
    machineSettings: 'Paramètres de la machine',
    uiGroupSelection: 'Sélection du groupe UI',
    selectUiGroup: 'Veuillez sélectionner le groupe UI',
    uiSelection: 'Sélection de l\'UI',
    searchUiName: 'Rechercher le nom de l\'UI',
    viewAll: 'Tous',
    viewSelected: 'Sélectionnés uniquement',
    builtIn: 'Intégré',
    notBuiltIn: 'Non intégré',
    productSelection: 'Sélection de produits',
    searchProductName: 'Rechercher le nom du produit',
    selectAll: 'Tout sélectionner',
    frameSelection: 'Sélection de cadres',
    selectProductFirst: 'Veuillez d\'abord sélectionner un produit',
    searchFrameName: 'Rechercher le nom du cadre',
    noProductSelected: 'Veuillez d\'abord sélectionner au moins un produit, puis sélectionnez un produit pour voir les cadres correspondants',
    noFrameData: 'Aucune donnée de cadre pour le produit actuel',
    filterSelection: 'Sélection de filtres',
    searchFilterName: 'Rechercher le nom du filtre',
    stickerGroup: 'Groupe d\'autocollants',
    searchGroupName: 'Rechercher le nom du groupe',
    noStickerGroupData: 'Aucune donnée de groupe d\'autocollants',
    stickersCount: '{count} autocollants',
    parameterSettings: 'Paramètres',
    photoTime: 'Temps de photo',
    seconds: 'secondes',
    inputPhotoTime: 'Veuillez entrer le temps de photo',
    intervalTime: 'Intervalle de temps',
    inputIntervalTime: 'Veuillez entrer l\'intervalle de temps',
    paperCount: 'Nombre de papiers',
    sheets: 'feuilles',
    inputPaperCount: 'Veuillez entrer le nombre de papiers',
    paperCountRequired: 'Le nombre de papiers est obligatoire',
    cancel: 'Annuler',
    save: 'Enregistrer',
    selectAtLeastOneProduct: 'Veuillez sélectionner au moins un produit',
    selectAtLeastOneFilter: 'Veuillez sélectionner au moins un filtre',
    paperCountMinLimit: 'Le nombre de papiers ne peut pas être inférieur à 50',
    serverConnectionError: 'Erreur de connexion au serveur, veuillez réessayer plus tard!',
    deviceThumbnail: 'Miniature de l\'appareil',
    modify: 'Modifier',
    upload: 'Téléverser',
    remoteDesktopInfo: 'Informations de bureau à distance',
    remoteDesktopPlaceholder: 'Veuillez saisir les informations de bureau à distance (code distant)',
    format: 'Formater',
    belongCategory: 'Catégorie',
    selectBelongCategory: 'Veuillez sélectionner la catégorie',
    onlyJpgPng: 'Seules les images JPG et PNG peuvent être téléversées~',
    exceed4M: 'Dépasse la limite de 4M, téléversement non autorisé~',
    thumbnailUploadFailed: 'Échec du téléversement de la miniature',
    jsonFormatErrorFormat: 'Format JSON invalide, impossible de formater, veuillez vérifier et réessayer',
    jsonFormatError: 'Format JSON invalide, veuillez vérifier et réessayer',
    showName: 'Nom d\'affichage de l\'appareil (Scannez le code QR pour télécharger le titre de la page de photos électroniques)',
    showNamePlaceholder: 'Affiché comme titre sur la page de téléchargement des photos électroniques'
  },
  personal: {
    oldPassword: 'Ancien mot de passe',
    inputOldPassword: 'Veuillez saisir l\'ancien mot de passe',
    strength: 'Force : ',
    passwordTip: 'Veuillez saisir au moins 6 caractères. N\'utilisez pas de mot de passe facile à deviner.',
    newPassword: 'Nouveau mot de passe',
    passwordPlaceholder: 'Au moins 6 caractères, sensible à la casse',
    confirmPassword: 'Confirmer à nouveau',
    confirmPasswordPlaceholder: 'Confirmer le mot de passe',
    levelLow: 'Faible',
    levelMedium: 'Moyen',
    levelStrong: 'Fort',
    minSixChars: 'Veuillez saisir un mot de passe d\'au moins 6 caractères',
    strengthNotEnough: 'La force du mot de passe est insuffisante',
    inputPassword: 'Veuillez saisir le mot de passe',
    passwordNotMatch: 'Les deux mots de passe ne correspondent pas',
    oldPasswordIncorrect: 'L\'ancien mot de passe est incorrect',
    editProfile: 'Modifier le profil',
    updateAvatar: 'Changer d\'avatar',
    avatarAlt: 'Avatar',
    avatarUpdateSuccess: 'Avatar mis à jour avec succès',
    email: 'E-mail',
    mobile: 'Mobile',
    dept: 'Service',
    gender: 'Sexe',
    description: 'Description',
    inputEmail: 'Veuillez saisir l\'e-mail',
    inputMobile: 'Veuillez saisir le numéro de mobile',
    emailInvalid: 'Veuillez saisir un e-mail valide',
    emailMax: 'La longueur ne peut pas dépasser 50 caractères',
    mobileInvalid: 'Veuillez saisir un numéro de mobile valide',
    selectGender: 'Veuillez sélectionner le sexe',
    descMax: 'La longueur ne peut pas dépasser 100 caractères',
    submit: 'Soumettre',
    selectAvatar: 'Choisir un avatar',
    clickToSelect: 'Cliquez pour sélectionner',
    updatingWarning: 'Mise à jour de l\'avatar, ne cliquez pas plusieurs fois',
    updateAvatarFailed: 'Échec de la mise à jour de l\'avatar',
    tabHthz: 'Houtian Huazi',
    tabAl: 'Série Ali',
    tabLm: 'LianMeng'
  },
  userInfo: {
    title: 'Infos utilisateur',
    account: 'Compte : ',
    role: 'Rôle : ',
    noRole: 'Aucun rôle',
    male: 'Masculin',
    female: 'Féminin',
    confidential: 'Confidentiel',
    department: 'Service : ',
    noDepartment: 'Aucun service',
    gender: 'Sexe : ',
    phone: 'Téléphone : ',
    noPhone: 'Téléphone non lié',
    email: 'E-mail : ',
    noEmail: 'E-mail non lié',
    status: 'Statut : ',
    locked: 'Verrouillé',
    valid: 'Actif',
    createTime: 'Créé : ',
    lastLogin: 'Dernière connexion : ',
    description: 'Description : '
  },
  remotePrint: {
    loading: 'Chargement...',
    expired: 'Enregistrement expiré',
    expiredDesc: 'Cet enregistrement a expiré. Veuillez retourner au terminal et réessayer.',
    completed: 'Terminé',
    completedDesc: 'Les photos ont été envoyées avec succès. Veuillez attendre près du terminal pour l\'impression.',
    submitted: 'Envoyé',
    submittedDesc: 'Les photos ont été envoyées au terminal. Veuillez effectuer les opérations suivantes sur l\'appareil.',
    orderInfo: 'Info commande',
    recordCode: 'Nº d\'enregistrement',
    orderCode: 'Nº de commande',
    product: 'Produit',
    price: 'Prix',
    expireTime: 'Expire à',
    photos: 'Photos',
    addPhoto: 'Ajouter photo',
    tipFormat: 'Seuls les formats JPG/PNG sont pris en charge',
    tipSize: 'Chaque photo ne doit pas dépasser 3 Mo',
    tipExpire: 'L\'enregistrement est valide 5 minutes, veuillez téléverser rapidement',
    submit: 'Téléverser & Imprimer',
    submitting: 'Envoi en cours...',
    noRecordCode: 'Code d\'enregistrement manquant. Veuillez scanner le code QR.',
    loadFailed: 'Échec du chargement. Veuillez réessayer.',
    invalidFormat: 'Seul JPG/PNG est pris en charge',
    photoLimit: 'Vous pouvez télécharger jusqu\'à {count} photos',
    fileTooLarge: 'La taille du fichier ne peut pas dépasser 10 Mo',
    uploadFailed: 'Échec du téléversement. Veuillez réessayer.',
    noPhotoUploaded: 'Veuillez téléverser au moins une photo',
    submitFailed: 'Échec de l\'envoi. Veuillez réessayer.'
  }
}



// WEBPACK FOOTER //
// ./src/lang/fr-FR.js